// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'd439f3dbe828b605f24bee265b62a67909482c87';
export const BUILD_NUMBER = '194';
export const BUILD_TIMESTAMP = '2026-07-13T06:46:58.280Z';
